import * as React from 'react';
import AnimateHeight from 'react-animate-height';
/**
 * A component that can be optionally used as the accordion's content to
 * automatically apply open animations.
 */
export const AccordionContent = props => {
  return React.createElement(
    AnimateHeight,
    { height: props.isOpen ? 'auto' : 0 },
    props.children || React.createElement(React.Fragment, null)
  );
};
export default class Accordion extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      openIndexes: (
        this.props.initialOpenIndexes || [this.props.atLeastOne && 0]
      ).filter(el => isFinite(el))
    };
    this.close = index => {
      this.setState(prevState => {
        const openCount = prevState.openIndexes.length;
        return {
          openIndexes:
            this.props.atLeastOne &&
            openCount === 1 &&
            prevState.openIndexes.includes(index)
              ? prevState.openIndexes
              : prevState.openIndexes.filter(i => i !== index)
        };
      });
    };
    this.open = index => {
      this.setState(prevState => {
        const openIndexes = this.props.single
          ? [index]
          : [...prevState.openIndexes, index];
        return {
          openIndexes
        };
      });
    };
    this.handleItemClick = index => {
      // Determine whether we are closing or opening this accordion item
      const action = this.state.openIndexes.includes(index)
        ? 'closing'
        : 'opening';
      if (action === 'closing') {
        this.close(index);
      } else {
        this.open(index);
      }
    };
  }
  render() {
    return this.props.children({
      openIndexes: this.state.openIndexes,
      handleClick: this.handleItemClick,
      AccordionContent
    });
  }
}
